webpackJsonp([263791100135453],{

/***/ 240:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(240);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutFacts = function AboutFacts() {
	    return _react2.default.createElement(
	        'ul',
	        { className: 'about-facts heading-font' },
	        _react2.default.createElement(
	            'li',
	            { className: 'about-fact' },
	            _react2.default.createElement(
	                'div',
	                { className: 'about-fact__highlight' },
	                '36'
	            ),
	            'years of experience'
	        ),
	        _react2.default.createElement(
	            'li',
	            { className: 'about-fact' },
	            _react2.default.createElement(
	                'div',
	                { className: 'about-fact__highlight' },
	                '2'
	            ),
	            'major product lines'
	        ),
	        _react2.default.createElement(
	            'li',
	            { className: 'about-fact' },
	            _react2.default.createElement(
	                'div',
	                { className: 'about-fact__highlight about-fact__highlight--smaller' },
	                'Men\'s Night'
	            ),
	            'tuesday evenings are men\'s night.',
	            _react2.default.createElement('br', null),
	            'no appointments necessary,',
	            _react2.default.createElement('br', null),
	            'but waiting times may vary.'
	        )
	    );
	};
	
	exports.default = AboutFacts;
	module.exports = exports['default'];

/***/ }),

/***/ 193:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(12);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	__webpack_require__(193);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Banner = function Banner(_ref) {
	    var title = _ref.title,
	        image = _ref.image;
	    return _react2.default.createElement(
	        'div',
	        { className: 'banner', style: { backgroundImage: 'url(' + image + ')' } },
	        _react2.default.createElement(
	            _ContentWrapper2.default,
	            null,
	            title && _react2.default.createElement('h2', { className: 'banner__title heading-font', dangerouslySetInnerHTML: { __html: title } })
	        )
	    );
	};
	
	exports.default = Banner;
	module.exports = exports['default'];

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hair-from-back.0e9d9751.jpg";

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stylist.64ea1f98.jpg";

/***/ }),

/***/ 396:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactHelmet = __webpack_require__(71);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(194);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _AboutFacts = __webpack_require__(210);
	
	var _AboutFacts2 = _interopRequireDefault(_AboutFacts);
	
	var _Banner = __webpack_require__(83);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _hairFromBack = __webpack_require__(466);
	
	var _hairFromBack2 = _interopRequireDefault(_hairFromBack);
	
	var _ContentWrapper = __webpack_require__(12);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _stylist = __webpack_require__(471);
	
	var _stylist2 = _interopRequireDefault(_stylist);
	
	__webpack_require__(396);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About() {
	    return _react2.default.createElement(
	        'main',
	        null,
	        _react2.default.createElement(_reactHelmet2.default, { title: 'About Us | TNT Cuts' }),
	        _react2.default.createElement(_Banner2.default, {
	            image: _hairFromBack2.default,
	            title: 'About Us'
	        }),
	        _react2.default.createElement(
	            _ContentWrapper2.default,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'about-text' },
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'TNT Cuts is a full service hair salon located in Kittanning, Pennsylvania. It is owned and operated by Patti Fiscus. We offer a wide range of products; ranging from Redken, Bed Head, Nioxin, Sexyhair, and Rockaholic, along with an extensive list of services.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'TNT Cuts offers dedicated, casual, quiet, and comfortable servicing for all clientele. Owner Patti Fiscus provides more than 31 years of experience!'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Freshen up your look with adult and kids cuts, styles, color, perms, high styling, foil and cap highlighting, low lighting, and facial waxing.'
	                )
	            ),
	            _react2.default.createElement(_AboutFacts2.default, null),
	            _react2.default.createElement(
	                'div',
	                { className: 'about-stylist' },
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Patti Fiscus, owner and stylist'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'about-stylist-content' },
	                    _react2.default.createElement('img', { className: 'about-stylist-content__image', src: _stylist2.default }),
	                    _react2.default.createElement(
	                        'section',
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'She has 31 years of experience in the industry.'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'The salon offers a variety of looks for the entire family at practical prices including cutting, styling, perming, coloring, facial waxing, and high styling updos.'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'The salon takes pride in using Redken\xAE, and NIOXIN\xAE products, also available for retail.'
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = About;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-e444e5237a77fb16b6c8.js